import { Toast } from 'vant'

export const isIOS = () => {
  return /(iPhone|iPad|Ipod|iOS)/i.test(navigator.userAgent)
}

// export const getUrlParam = (url, name) => {
//   try {
//     // 检查是否是hash路由模式
//     if (url.includes('#')) {
//       // 处理hash路由中的查询参数
//       const hashPart = url.split('#')[1]
//       if (hashPart && hashPart.includes('?')) {
//         const queryString = hashPart.split('?')[1]
//         const params = new URLSearchParams(queryString)
//         return params.get(name)
//       }
//     } else {
//       // 处理普通URL的查询参数
//       const params = new URLSearchParams(new URL(url).search)
//       return params.get(name)
//     }
//     return null
//   } catch (error) {
//     console.error('解析URL参数失败:', error)
//     return null
//   }
// }

export const getUrlParam = (url, name) => {
  try {
    const urlObj = new URL(url)
    
    // 首先检查主URL的查询参数（如 ?code=xxx）
    let param = urlObj.searchParams.get(name)
    if (param) {
      return param
    }
    
    // 然后检查hash部分的查询参数（如 #/login?code=xxx）
    if (urlObj.hash && urlObj.hash.includes('?')) {
      const hashQueryString = urlObj.hash.split('?')[1]
      const hashParams = new URLSearchParams(hashQueryString)
      param = hashParams.get(name)
      if (param) {
        return param
      }
    }
    
    return null
  } catch (error) {
    console.error('解析URL参数失败:', error)
    return null
  }
}

/**
 * @description 清理URL中的code参数
 */
export function removeCodeFromUrl() {
  try {
    const url = window.location.href
    // 检查是否包含code参数
    if (url.includes('code=')) {
      // 获取当前的hash路径
      const hash = window.location.hash
      // 构建新的URL（只保留协议、域名、路径和hash）
      const newUrl = window.location.origin + window.location.pathname + hash
      // 使用replaceState替换当前历史记录，不会触发页面刷新
      window.history.replaceState(null, null, newUrl)
      console.log('已清理URL中的code参数')
    }
  } catch (error) {
    console.error('清理URL参数失败:', error)
  }
}

/**
 * @description 微信支付 api 封装
 * @param {String} paydata 微信支付参数,JSON字符串
 * @returns 用户操作
 */
export function pay({ timeStamp, nonceStr, package: payPackage, signType, paySign, appId }, wx) {
  return new Promise((resolve, reject) => {
    wx.chooseWXPay({
      timestamp: timeStamp,
      nonceStr,
      package: payPackage,
      signType,
      paySign,
      appId,
      success: res => {
        console.log(res, '支付成功')
        resolve()
      },
      fail: function (res) {
        console.log(res, '支付失败')
        reject('支付失败')
        // Toast('支付失败')
      }
    })
  })
}

export function traverseTree(node, callback) {
  callback(node)
  if (node.child) {
    for (const child of node.child) {
      traverseTree(child, callback)
    }
  }
}

export function findMaxDepth(node, depth = 0) {
  if (!node) {
    return 0
  }
  let maxDepth = depth
  if (node.child) {
    for (const child of node.child) {
      const childDepth = findMaxDepth(child, depth + 1)
      maxDepth = Math.max(maxDepth, childDepth)
    }
  }
  return maxDepth
}

// 通过ids找到tree子元素
export function findNodeByIds(ids, tree) {
  if (ids.length === 0) {
    return tree
  }
  const id = ids[0]
  const node = tree.find(item => item.id === id)
  if (!node) {
    return null
  }
  return findNodeByIds(ids.slice(1), node.child)
}

// 通过一个id找到tree子元素
export function findNodeById(id, tree) {
  if (!tree) {
    return null
  }
  if (tree.id === id) {
    return tree
  }
  if (tree.child) {
    const node = findNodeById(id, tree.child)
    if (node) {
      return node
    }
  }
  return null
}
